const API_URL = '/api';

// This function safely gets initData. In a non-Telegram environment, it returns a placeholder for development.
const getInitData = () => {
  if (window.Telegram && window.Telegram.WebApp) {
    return window.Telegram.WebApp.initData;
  }
  // FOR LOCAL DEVELOPMENT ONLY. Replace with a valid initData string from your bot for testing.
  // DO NOT DEPLOY THIS TO PRODUCTION
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_TELEGRAM_INIT_DATA || '';
  }
  return '';
};

async function request(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;
  
  const initData = getInitData();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  // Add Telegram initData to header for protected routes
  if (initData) {
    headers['X-Telegram-Init-Data'] = initData;
  }

  const config = {
    ...options,
    headers,
  };

  if (options.body && typeof options.body !== 'string') {
    config.body = JSON.stringify(options.body);
  }

  const response = await fetch(url, config);
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Произошла ошибка' }));
    // Try to get a more specific error message
    const message = errorData.error || response.statusText || 'Что-то пошло не так';
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }
  
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }
  
  return response;
}

// Materials
export const getMaterials = () => request('/materials');
export const getMaterial = (id) => request(`/materials/${id}`);
export const createMaterial = (data) => request('/materials', { method: 'POST', body: data });
export const updateMaterial = (id, data) => request(`/materials/${id}`, { method: 'PUT', body: data });
export const deleteMaterial = (id) => request(`/materials/${id}`, { method: 'DELETE' });

// Categories
export const getCategories = () => request('/categories');
export const createCategory = (data) => request('/categories', { method: 'POST', body: data });
export const updateCategory = (id, data) => request(`/categories/${id}`, { method: 'PUT', body: data });
export const deleteCategory = (id) => request(`/categories/${id}`, { method: 'DELETE' });

// Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);

  const initData = getInitData();
  const headers = {};
  if (initData) {
    headers['X-Telegram-Init-Data'] = initData;
  }

  const response = await fetch(`${API_URL}/upload`, {
    method: 'POST',
    body: formData,
    headers, // Pass headers here
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Upload failed' }));
    throw new Error(error.error || 'Something went wrong');
  }

  return response.json();
};

// Export / Import
export const exportData = async () => {
    const response = await fetch(`${API_URL}/export`);
    if (!response.ok) throw new Error('Export failed');
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `export-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const importData = (data) => request('/import', { method: 'POST', body: data });

// Admins
export const getAdmins = async () => {
  const response = await fetch('/api/admins');
  if (!response.ok) throw new Error('Не удалось получить список админов');
  return response.json();
}; 